/**
 * Material Symbols：仅在客户端 idle 后注入，避免阻塞 FCP/LCP 关键路径（勿写入 SSR head）。
 * FAQ 等轻量区块请用内联 SVG，不要调用本 composable。
 */
export function useMarketingFonts() {
  if (!import.meta.client) return

  const schedule = () => {
    const href =
      'https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0&display=swap'

    const load = () => {
      if (document.querySelector('link[data-lip-material-symbols]')) return
      const link = document.createElement('link')
      link.rel = 'stylesheet'
      link.href = href
      link.dataset.lipMaterialSymbols = '1'
      link.media = 'print'
      link.onload = () => {
        link.media = 'all'
      }
      document.head.appendChild(link)
    }

    if (typeof requestIdleCallback === 'function') {
      requestIdleCallback(load, { timeout: 6000 })
    } else {
      setTimeout(load, 3000)
    }
  }

  onMounted(() => {
    if (document.readyState === 'complete') {
      schedule()
    } else {
      window.addEventListener('load', schedule, { once: true, passive: true })
    }
  })
}
